export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">精彩推荐</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              编辑精选热门视频合集与影视大全新发现，每日品质推荐
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
            {/* Card 1 */}
            <div className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[4/3] bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20card%20background%20with%20subtle%20warm%20gradient%2C%20soft%20ambient%20lighting%2C%20clean%20aesthetic%2C%20professional%20quality%2C%20abstract%2C%20coral%20warm%20tone&width=600&height=450&seq=cards-01&orientation=landscape"
                  alt="妖精视频新片推荐"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                    新片
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug">
                  妖精视频本月必看十大热门视频合集
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2">
                  精选妖精视频月度热播内容，影视大全必收清单
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">07-30 更新</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                    查看详情 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[4/3] bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Entertainment%20media%20thumbnail%20with%20cinematic%20lighting%2C%20warm%20tones%2C%20elegant%20composition%2C%20professional%20visual%2C%20high%20detail%2C%20amber%20highlights&width=600&height=450&seq=cards-02&orientation=landscape"
                  alt="桃花视频热门合集"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
                    热门
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug">
                  桃花视频独家策划：夏日清凉特辑影视大全
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2">
                  桃花视频精心策划夏日主题热门视频合集
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">07-29 更新</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                    查看详情 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[4/3] bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20video%20content%20card%20design%20with%20coral%20accents%2C%20modern%20layout%2C%20soft%20shadows%2C%20editorial%20quality%2C%20warm%20atmosphere%2C%20professional&width=600&height=450&seq=cards-03&orientation=landscape"
                  alt="苹果视频高分推荐"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-secondary-600 text-background-50 whitespace-nowrap">
                    高分
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug">
                  苹果视频评分9.0+影视大全新片合辑
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2">
                  苹果视频高分好片影视大全合集不容错过
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">07-28 更新</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                    查看详情 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[4/3] bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Streaming%20platform%20content%20card%20with%20gradient%20overlay%2C%20warm%20color%20palette%2C%20professional%20visual%20design%2C%20cinematic%20mood%2C%20elegant%2C%20golden%20warm%20light&width=600&height=450&seq=cards-04&orientation=landscape"
                  alt="榴莲视频每周速递"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                    速递
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug">
                  榴莲视频每周影视大全精选速递合集
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2">
                  榴莲视频一周精选内容滚动更新热门视频合集
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">07-27 更新</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                    查看详情 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>

            {/* Card 5 */}
            <div className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[4/3] bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Digital%20media%20showcase%20card%20with%20amber%20highlights%2C%20modern%20composition%2C%20clean%20aesthetic%2C%20professional%20quality%2C%20atmospheric%20lighting%2C%20warm%20coral%20tones%2C%20editorial&width=600&height=450&seq=cards-05&orientation=landscape"
                  alt="综合平台推荐合集"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
                    精选
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug">
                  五大平台联推：热门视频合集终极盘点
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2">
                  妖精+桃花+苹果+榴莲+豆花联合精选影视大全
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">07-26 更新</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                    查看详情 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}